export { CollapseDirective } from './collapse.directive';
export { CollapseModule } from './collapse.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ngx-bootstrap/collapse/index.js
// module id = ../../../../ngx-bootstrap/collapse/index.js
// module chunks = 7